export const RTE_RENDERER_VARIANT = {
  PARAGRAPH: 'paragraph',
  HEADING: 'heading',
} as const;

export type RteRendererVariants = (typeof RTE_RENDERER_VARIANT)[keyof typeof RTE_RENDERER_VARIANT];
